import { VolleyballIncidentId } from '@collector/sportsapi-client-legacy'
import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

export const MatchBallPopup = new PopupBuilder('MatchBall', {
  incident_id: VolleyballIncidentId.MatchBall,
})
  .withTeamSelection()
  .omitDetailsView()
  .build()
